import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../../imageService';
import classNames from 'classnames';

const WelcomeAgeVerificationScreen = ({
  handleNextVerificationScreen,
  setScreenNumber,
  isDarkMode = false
}) => {
  const whyAskModalRef = useRef(null);
  const [dismissModal, setDismissModal] = useState(false);
  const [whyWeAskModal, setWhyWeAskModal] = useState(false);

  const handleMoreInfoClick = () => {
    window.open(
      'https://www.pmi.com/who-we-are/our-views-and-standards/our-views/health-effects-of-smoking-tobacco',
      'blank'
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        whyAskModalRef.current &&
        !whyAskModalRef.current.contains(event.target)
      ) {
        setWhyWeAskModal(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      className={classNames(styles.container, isDarkMode && styles.darkMode)}
      style={{
        backgroundImage: isDarkMode ? null : `url("${getImageFromS3('images/ua-brand/bg.png')}")`,
        overflow: dismissModal ? 'hidden' : 'auto'
      }}
    >
      <div className={classNames(styles.content, isDarkMode && styles.darkModeContent)}>
        <p className={styles.title}>Давай спочатку перевіримо твій вік</p>
        <p className={styles.description}>
          Ми зробимо це за декілька секунд, просто поглянувши на твоє обличчя
        </p>
        <p className={styles.info}>Ми не зберігаємо твоє фото</p>
        <p className={styles.buttonHeadTitle}>
          Ти старше 18 років та споживаєш тютюн?
        </p>
        <button
          className={styles.acceptButton}
          onClick={handleNextVerificationScreen}
        >
          Так
        </button>
        <button
          className={styles.dismissButton}
          onClick={() => setDismissModal(true)}
        >
          Ні
        </button>
        <p className={styles.infoDescription}>
          Цей додаток містить інформацію про тютюновмісний продукт і призначений
          для осіб старше 18 років, які споживають тютюн у тій чи іншій формі та
          проживають на території України.<br></br>
          Куріння тютюновмісних виробів викликає серйозні захворювання та
          призводить до звикання.
        </p>
        <p className={styles.moreInfo} onClick={handleMoreInfoClick}>
          Дізнатися більше>
        </p>
        <p
          className={styles.whyWeAsk}
          onClick={() => setWhyWeAskModal(!whyWeAskModal)}
        >
          Чому ми запитуємо?
        </p>
        {whyWeAskModal && (
          <div className={styles.whyWeAskModal}>
            <div className={styles.scrollWrapper}>
              <p className={styles.title}>
                Чому ми перевіряємо ваш вік і як це відбувається?
              </p>
              <p className={styles.text}>
                {'Ми є членами групи Philip Morris International. Веб-сайт і контент, якими ти збираєшся користуватись, призначені лише для повнолітніх курців та/або користувачів пристроїв для споживання тютюнових виробів без їх згоряння.\n' +
                  'Щоб отримати доступ, необхідно пройти перевірку віку. Для цього достатньо сфотографувати або завантажити фото: (i) свого обличчя і/або (ii) свого ідентифікаційного документу, якщо нам не вдалося підтвердити вік за допомогою твого особистого фото.\n\n' +
                  'Це автоматизований процес, щоб переконатись, що ти дорослий/-а. Якщо ти проти перевірки, не завантажуй свої фото чи ідентифікаційний документ та закрий браузер.\n' +
                  'Звертаємо твою увагу, що доступність процесу перевірки віку та його детальна послідовність можуть змінюватись в залежності від країни проживання та законодавчих вимог.\n\n' +
                  'Ми опрацьовуємо персональні дані відповідно до нашої Політики конфіденційності. Також ми використовуємо cookies згідно з нашою політикою.\n' +
                  'Підтвердження за допомогою перевірки обличчя\n' +
                  'Для цього потрібно завантажити своє особисте фото.\n\n' +
                  'Будь-ласка, враховуй наступні вимоги:\n' +
                  'Лише одне обличчя та пара очей на фото (перевір наявність постерів позаду);\n' +
                  'Зніми окуляри;\n' +
                  'Не стій напроти вікна;\n' +
                  'Фото має бути у відповідних якості та розмірах (не надто світле/темне /яскраве, чітке, як мінімум 1000x1000 пікселів);\n' +
                  'При завантаженні дозволені формати JPG і PNG та розмір до 5MB.\n\n' +
                  'Не дозволяється:\n' +
                  'Просити сторонніх пройти перевірку замість себе;\n' +
                  'Використовувати чужі фото;\n' +
                  'Використовувати фото, що належать іншим.\n\n' +
                  'Тому вам необхідно пройти процес перевірки віку. Для цього ви маєте зробити або завантажити фото:\n   1. Себе; та/або    2. Якщо ми не можемо підтвердити ваш вік за вашим фото – вашого документа, що посвідчує особу, як це визначено нами.  Цей процес є автоматизованим і здійснюється лише для підтвердження вашого повноліття. Якщо ви не бажаєте проходити перевірку, просто не надсилайте фото або документ і закрийте браузер.  Зверніть увагу, що доступність процесу перевірки віку та його деталі можуть відрізнятися залежно від вашої країни проживання та місцевого законодавства.  Ми оброблятимемо ваші персональні дані відповідно до нашого Повідомлення про конфіденційність. Також ми використовуємо файли cookie відповідно до нашого Повідомлення про використання файлів cookie.'}
              </p>
              <p className={styles.title}>Перевірка віку за фото</p>
              <p className={styles.text}>
                {'Для проходження перевірки таким способом необхідно зробити або завантажити своє фото.\n\n Будь ласка, врахуйте такі вимоги:\n' +
                  'На фото має бути лише одне обличчя та пара очей (уникайте плакатів або відображень позаду вас).\n' +
                  'Зніміть окуляри.\n' +
                  'Не ставайте перед вікном.\n' +
                  'Фото має бути відповідного розміру та якості (не надто темне або яскраве, достатньо чітке, розмір не менше 1000x1000 пікселів).\n' +
                  'Якщо використовуєте метод «Завантаження», приймаються формати JPG та PNG, розміром менше 5MB.\n\n' +
                  'Ви не маєте права:\n' +
                  'Просити когось іншого пройти перевірку віку за вас.\n' +
                  'Використовувати фото іншої людини.\n' +
                  'Використовувати чужі фото без дозволу.'}
              </p>
              <p className={styles.title}>Перевірка віку за документом</p>
              <p className={styles.text}>
                {'Для проходження перевірки таким способом необхідно подати ваш документ, що посвідчує особу, як це визначено нами.\n\n' +
                  'Будь ласка, врахуйте такі вимоги:\n' +
                  'Фото має бути відповідного розміру та якості (не надто темне або яскраве, достатньо чітке, розмір не менше 1000x1000 пікселів).\n' +
                  'Якщо використовуєте метод «Завантаження», приймаються формати JPG та PNG, розміром менше 5MB.\n\n' +
                  'Ви не маєте права:\n' +
                  'Просити когось іншого пройти перевірку віку за вас.\n' +
                  'Використовувати документи, що належать іншим особам.'}
              </p>
            </div>
          </div>
        )}
        {whyWeAskModal && (
          <svg
            width="19"
            height="11"
            viewBox="0 0 19 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.5 11L0 0L19 0L9.5 11Z"
              fill="black"
              fillOpacity="0.86"
            />
          </svg>
        )}
      </div>
      <div className={styles.footerContainer}>
        <a href="https://www.pmiprivacy.com/ukraine/uk/consumer/">
          Політика конфіденційності
        </a>
        <button onClick={() => setScreenNumber(2)}>Умови використання</button>
        <button onClick={() => setScreenNumber(3)}>FAQ</button>
        <button onClick={() => setScreenNumber(4)}>
          Параметри застосування файлів cookie
        </button>
      </div>
      {dismissModal && (
        <div
          className={styles.dismissModal}
          onClick={() => setDismissModal(false)}
        >
          Цей сайт вміщує інформацію про продукти, які містять тютюн, і
          призначений тільки для повнолітніх курців.
        </div>
      )}
    </div>
  );
};

export default WelcomeAgeVerificationScreen;
